import React, { useEffect, useState } from 'react';
import { getCoachImage, getClientImage } from '../services/service';

export interface ImageProps {
  isClient: boolean;
  id: number;
  compact?: boolean;
}

export const Image: React.FC<ImageProps> = (props) => {
  const [image, setImage] = useState<string>('');

  useEffect(() => {
    const load = async () => {
      const placeholderImg = '/default-avatar-profile.jpeg';
      const profileImg = props.isClient ? await getClientImage(props.id) : await getCoachImage(props.id);
      setImage(profileImg || placeholderImg);
    };

    load().catch(console.error);
  }, [props.id, props.isClient]);

  return (
    <div className={`avatar ${props.compact ? 'compact' : ''}`} style={{ backgroundImage: `url(${image})` }} />
  );
};
